
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/testimonials",
      function () {
        return require("private-next-pages/testimonials.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/testimonials"])
      });
    }
  